// extracted by mini-css-extract-plugin
module.exports = {"root":"Param_root__3isg3","valueCheck":"Param_valueCheck__1vWDr","valueCross":"Param_valueCross__23gnC"};